import { useEffect, useState } from "react";
import { MapPin, Navigation, Car, Building2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ADDRESS, MAPS_URL } from "@/components/Footer";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

export const announceBooking = () => window.dispatchEvent(new Event("ar:booked"));

export function FirstVisitLocation() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [parking, setParking] = useState("");
  useEffect(() => {
    if (!user || user.role !== "parent") { return undefined; }
    let timer;
    const show = () => { if (document.querySelector("[role=dialog]")) { timer = setTimeout(show, 1000); } else { setOpen(true); } };
    const onBooked = async () => {
      try {
        const { data } = await api.get("/me/location-intro");
        if (!data.seen) { setParking(data.parking_note || ""); timer = setTimeout(show, 1200); }
      } catch (e) { /* ignore */ }
    };
    window.addEventListener("ar:booked", onBooked);
    return () => { window.removeEventListener("ar:booked", onBooked); clearTimeout(timer); };
  }, [user]);
  const close = () => { setOpen(false); api.post("/me/location-intro/seen").catch(() => {}); };
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) { close(); } }}>
      <DialogContent className="max-w-md rounded-3xl max-h-[92vh] overflow-y-auto" data-testid="location-intro-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl text-navy flex items-center gap-2"><MapPin className="w-6 h-6 text-[#FF4D8D]" />Here's where to find us</DialogTitle>
          <DialogDescription>Welcome to Adventure Rock! Since this is your first booking, here's how to get here.</DialogDescription>
        </DialogHeader>
        <iframe title="Adventure Rock Bermuda map" src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`} className="w-full h-48 rounded-2xl border" loading="lazy" data-testid="location-intro-map" />
        <div className="space-y-2 text-sm text-navy">
          <p className="flex gap-2" data-testid="location-intro-address"><Building2 className="w-5 h-5 text-turquoise shrink-0" /><span><b>The Berkeley Cultural Center</b><br />23 Berkeley Road, <b>Second Floor</b>, Pembroke, Bermuda</span></p>
          {parking && <p className="flex gap-2 bg-[#FFF4D6] rounded-xl p-2" data-testid="location-intro-parking"><Car className="w-5 h-5 text-coral shrink-0" />{parking}</p>}
        </div>
        <div className="flex flex-col sm:flex-row gap-2">
          <a href={MAPS_URL} target="_blank" rel="noreferrer" className="flex-1"><Button className="w-full rounded-full bg-[#FFB703] hover:bg-[#FFB703]/90 text-navy font-bold" data-testid="location-intro-directions"><Navigation className="w-4 h-4 mr-2" />Get directions</Button></a>
          <Button variant="outline" onClick={close} className="flex-1 rounded-full" data-testid="location-intro-close">Got it</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
